// removed by extract-text-webpack-plugin
module.exports = {"myBullet":"_2bvsKxpPa--7xHT0xHKYWr","myBulletActive":"_3XkFRYq_8ogGi7PUnNwq_v"};


//////////////////
// WEBPACK FOOTER
// ./src/projects/easy/public/Comps/basic/Swiper.scss
// module id = 702
// module chunks = 12